import { HubData } from '../hooks/useHubData'

export interface UploadedDocState {
  uploaded: boolean
  signed: boolean
  fileName?: string
  processedWithNeela?: boolean
  signedDate?: string
  signedBy?: string
}

type PurchaseDocStatuses = Record<
  string,
  { uploaded?: boolean; signed?: boolean; uploadedAt?: string; fileName?: string }
>

export function readSalesHubUploads(phase1Data: HubData | null): {
  salesPurchaseAgreement: UploadedDocState
  preliminaryTitleReport: UploadedDocState
} {
  const spaUploaded = !!phase1Data?.salesPurchaseAgreementUploaded
  const spaProcessed = !!phase1Data?.hasExtractedWithNeela
  const titleUploaded = !!phase1Data?.preliminaryTitleReportUploaded
  const titleProcessed = !!phase1Data?.hasTitleReportExtracted
  return {
    salesPurchaseAgreement: {
      uploaded: spaUploaded,
      signed: false,
      processedWithNeela: spaProcessed,
    },
    preliminaryTitleReport: {
      uploaded: titleUploaded,
      signed: false,
      processedWithNeela: titleProcessed,
    },
  }
}

export function readIdentificationHubUploads(exchangeData: HubData | null): {
  settlementStatementRelinquished: UploadedDocState
} {
  const fromScope = !!exchangeData?.settlementUploaded
  const fromLocalStorage = typeof window !== 'undefined'
    && localStorage.getItem('identification_settlement_uploaded') === 'true'
  const uploaded = fromScope || fromLocalStorage
  const fileName = (exchangeData?.settlementFileName as string | undefined) ?? undefined
  return {
    settlementStatementRelinquished: { uploaded, signed: false, fileName },
  }
}

export function readPurchaseHubUploads(acquisitionData: HubData | null): {
  purchaseAgreementReplacement: UploadedDocState
  settlementStatementReplacement: UploadedDocState
} {
  const paFileName = (acquisitionData?.purchaseAgreementFileName as string | undefined) ?? undefined
  const paExtracted = !!(acquisitionData?.purchaseAgreementExtracted)
  const paUploaded = !!paFileName || paExtracted
  const docStatuses = (acquisitionData?.purchaseDocStatuses ?? {}) as PurchaseDocStatuses
  const hudKey = 'Settlement Statement (Replacement - HUD-1)'
  const hudState = docStatuses[hudKey]
  return {
    purchaseAgreementReplacement: {
      uploaded: paUploaded,
      signed: false,
      fileName: paFileName,
      processedWithNeela: paExtracted,
    },
    settlementStatementReplacement: {
      uploaded: !!hudState?.uploaded,
      signed: false,
      fileName: hudState?.fileName,
    },
  }
}

export function readDisbursementHubUploads(): {
  disbursementRequest: UploadedDocState
} {
  if (typeof window === 'undefined') {
    return { disbursementRequest: { uploaded: false, signed: false } }
  }
  const authSigned = localStorage.getItem('disbursement_auth_signed') === 'true'
  const signedDate = localStorage.getItem('disbursement_auth_signed_date') ?? undefined
  const signedBy = localStorage.getItem('disbursement_auth_signed_by') ?? undefined
  return {
    disbursementRequest: {
      uploaded: authSigned,
      signed: authSigned,
      signedDate,
      signedBy,
    },
  }
}
